import React, {
  useContext,
  useEffect,
  useState,
  useCallback,
} from 'react';
import { Grid } from '@mui/material';
import { toast } from 'react-toastify';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

import TextInput from '../common_component/TextInput';
import Button from '../single_component/Button';
import Text from '../single_component/Text';
import Box from '../single_component/Box';
// import TextLabel from '../single_component/TextLabel';
import UploadInput from '../../components/single_component/UploadInput';
import DocumentBox from '../common_component/DocumentBox';
import ProjectContext from '../../context/ProjectContext';

import Props from '../../types/props';

function DocumentTab({ ...props }: Props) {
  const { deleteMoreDocument, getProject } =
    useContext(ProjectContext);

  const {
    editDocuments = [],
    handleChangeDocument,
    DocumentType,
    state,
    addMoreField,
    handledocdelete,
  } = props.extra;

  const addNewDoc = state?.[DocumentType] ?? [];

  const [editedDocNames, setEditedDocNames] =
    useState<string[]>([]);

  useEffect(() => {
    setEditedDocNames(
      editDocuments.map(
        (doc: any) => doc?.documentName ?? ''
      )
    );
  }, [editDocuments]);

  const handleDocumentNameChange = useCallback(
    (index: number, value: string) => {
      setEditedDocNames(prev => {
        const updated = [...prev];
        updated[index] = value;
        return updated;
      });
    },
    []
  );

  const handleUploadChange = useCallback(
    (index: number, files: any[]) => {
      if (files?.length > 0) {
        handleChangeDocument(
          index,
          'file',
          DocumentType,
          files[0]
        );
      }
    },
    [handleChangeDocument, DocumentType]
  );

  const handleDeleteDocument = useCallback(
    async (docId: number, projectId: number) => {
      try {
        const response = await deleteMoreDocument(
          docId
        );

        if (response?.success) {
          toast.success(response?.message);

          if (projectId) {
            await getProject(projectId);
          }
        } else {
          toast.error(
            response?.message ||
              'Failed to delete document'
          );
        }
      } catch (error) {
        console.error(
          'Error deleting document:',
          error
        );
        toast.error('Failed to delete document');
      }
    },
    [deleteMoreDocument, getProject]
  );

  return (
    <Grid
      container
      columnSpacing={2}
      style={{
        paddingInline: 22,
        paddingBlock: 10,
      }}
    >
      {/* Existing Documents */}

      {editDocuments.map(
        (document: any, index: number) => (
          <React.Fragment
            key={
              document?.documentId ??
              `edit-${index}`
            }
          >
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={6}
            >
              <TextInput
                label="Document Name"
                placeholder="Enter Document Name"
                value={
                  editedDocNames[index] ??
                  document?.documentName ??
                  ''
                }
                onChange={(e: any) =>
                  handleDocumentNameChange(
                    index,
                    e.target.value
                  )
                }
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={6}
            >
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }}
              >
                <DocumentBox
                  extra={{
                    type: 'editMandate',
                    url: document?.documentFile,
                    textlabel: 'Upload Document',
                    labelWidth:
                      props?.extra?.labelWidth ??
                      '',
                    chiplabel:
                      editedDocNames[index] ||
                      document?.documentName,

                    handleDeleteDocuments: () =>
                      handledocdelete
                        ? handledocdelete(
                            document.documentId
                          )
                        : handleDeleteDocument(
                            document.documentId,
                            document.projectId
                          ),
                  }}
                />
              </Box>
            </Grid>
          </React.Fragment>
        )
      )}

      {/* New Documents */}

      {addNewDoc.map(
        (document: any, index: number) => (
          <React.Fragment
            key={
              document?.documentId ??
              document?.id ??
              `new-${index}`
            }
          >
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              mt={1}
              lg={6}
            >
              <TextInput
                label="Document Name"
                placeholder="Enter Document Name"
                value={
                  document?.documentName ?? ''
                }
                onChange={(e: any) =>
                  handleChangeDocument(
                    index,
                    'text',
                    DocumentType,
                    e.target.value
                  )
                }
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={6}
            >
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  marginTop: '6.5px',
                }}
              >
                <Box>
                  <Text
                    style={{
                      color: 'black',
                      marginBottom: '-6px',
                      marginTop: 10,
                      fontSize: 13,
                      fontWeight: 500,
                    }}
                  >
                    Upload Document
                  </Text>

                  <UploadInput
                    extra={{
                      docName:
                        document?.fileName ?? '',

                      onchange: (
                        files: any[]
                      ) =>
                        handleUploadChange(
                          index,
                          files
                        ),
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          </React.Fragment>
        )
      )}

      {/* Add More Button */}

      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        lg={6}
        style={{
          marginBottom: 6,
        }}
      >
        <Button
          extra={{
            variant: 'outlined',
          }}
          onClick={() =>
            addMoreField(DocumentType)
          }
          icons={<AddOutlinedIcon />}
          style={{
            marginTop: 1,
          }}
        >
          <Text
            style={{
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            Add Another Document
          </Text>
        </Button>
      </Grid>
    </Grid>
  );
}

export default React.memo(DocumentTab);